export const getYear = state => state.reportVehiclePerformance.getIn(['list', 'year'])
export const getData = state => state.reportVehiclePerformance.getIn(['list', 'data'])
export const getFetching = state => state.reportVehiclePerformance.getIn(['list', 'fetching'])
export const getError = state => state.reportVehiclePerformance.getIn(['list', 'error'])

export const getDetailsData = state => state.reportVehiclePerformance.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportVehiclePerformance.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportVehiclePerformance.getIn(['details', 'error'])
